const myStyles = theme => ({
  scrollable: {
    overflowY: "auto",
    height: `calc(100vh - 234px)`
  }
});

export default myStyles;
